// External Dependencies
import 'jquery';

// Standard imports
import common from './common';

// Standard init
common();
